module.exports = __webpack_public_path__ + "static/media/early_morning_light_small.d38d5aa4.jpg";